import { Box, Card, CardContent, Grid, Rating, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { CustomButton } from '../../../../../components';
import { APP_ROUTES } from '../../../../../constants/app-routes';
import { APPLICATION_STATUS } from '../../../../../constants/event-application-status';
import { updateEventApplicationStatus } from '../../../../../core/vendor-events/action';
import { useIsMobile, useStorageImage } from '../../../../../hooks';

function CardActions({ vendor, handleApprove, handleDeny, isMobile }) {
  return (
    <Grid item xs={12} sm={9} px={isMobile ? 0 : 4}>
      <Box display="flex">
        <Typography variant="body1" fontWeight="bold" pr={isMobile ? 3 : 0}>
          {isMobile ? 'Rating:' : 'fayVen Community Rating:'}
        </Typography>
        <Rating value={vendor.averageScore} disabled />
      </Box>
      <Box display="flex" mt={2} columnGap={2} justifyContent="space-between">
        <CustomButton variant="contained" onClick={handleApprove}>
          Approve
        </CustomButton>
        <CustomButton variant="outlined" onClick={handleDeny}>
          Deny
        </CustomButton>
      </Box>
    </Grid>
  );
}

CardActions.propTypes = {
  vendor: PropTypes.instanceOf(Object).isRequired,
  handleApprove: PropTypes.func.isRequired,
  handleDeny: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
};

function ApplicationCard({ vendorEvent, onStatusChanged }) {
  const dispatch = useDispatch();
  const isMobile = useIsMobile();
  const { vendor, vendor_event_contact: contact } = vendorEvent;
  const image = useStorageImage(vendor.image);

  useEffect(() => {
    console.log('🍉 contact ', contact);
    console.log('🍉 vendor ', vendor);
  }, [contact]);

  const changeStatus = (newStatus) => {
    dispatch(
      updateEventApplicationStatus(vendor.id, vendorEvent.fk_event, newStatus, onStatusChanged),
    );
  };

  const handleApprove = () => changeStatus(APPLICATION_STATUS.APPROVED);

  const handleDeny = () => changeStatus(APPLICATION_STATUS.DENIED);

  return (
    <Grid container mb={2}>
      <Grid item xs={12} sm={3}>
        <Card>
          {image && <img src={image} alt="Vendor profile" />}
          <CardContent>
            <Typography variant="body1" fontWeight="bold">
              <Link to={APP_ROUTES.VENDOR_PUBLIC_PROFILE.replace(':vendorId', vendor.id)}>
                {vendor.name}
              </Link>
            </Typography>
            <Typography>Contact: {contact?.name}</Typography>
            {/* <Typography>{contact.phone_number}</Typography>
            <Typography>{contact.email}</Typography> */}
            <Typography>Est. {new Date(vendor.created_at).getFullYear()}</Typography>
            {isMobile && (
              <CardActions
                vendor={vendor}
                handleApprove={handleApprove}
                handleDeny={handleDeny}
                isMobile={isMobile}
              />
            )}
          </CardContent>
        </Card>
      </Grid>
      {!isMobile && (
        <CardActions
          vendor={vendor}
          handleApprove={handleApprove}
          handleDeny={handleDeny}
          isMobile={isMobile}
        />
      )}
    </Grid>
  );
}

ApplicationCard.propTypes = {
  vendorEvent: PropTypes.instanceOf(Object).isRequired,
  onStatusChanged: PropTypes.func.isRequired,
};

export default ApplicationCard;
